<section *ngIf="pageData">
    <h2 class="header">{{ pageHeader | lowercase }}</h2>
    <div class="progress-block">
        <div *ngIf="(isIcopPlanSwitch && isUnlimited && !isFailure)">
            <div class="icop-promotion" *ngFor="let promotionContent of allPromoContent">
                <div
                    [ngClass]="promotionContent.type === 'notification' ? 'promo-content-notification' : 'promo-content-alert'">
                    <xm-media-image class="icon" [imageOptions]="getPromoIcon(promotionContent.icon)"></xm-media-image>
                    <p>{{ promotionContent.success }}</p>
                </div>
            </div>
        </div>
        <h2 class="progress-header">{{ pageContent.header }}</h2>
        <div class="shadow-circle" *ngIf="!isFailure">
            <div class="progress-circle"></div>
            <div class="content-holder">
                <div class="data-content" *ngIf="(!isUnlimited && (!user.account.isSegmentFive && !user.account.isSegmentSix && !isCbmGemini))">
                    <span class="value">{{ eligiblePlanDetails?.sharedDataGB }}</span>
                    <span class="unit">{{ pageContent?.dataUnit }}</span>
                </div>
                <div class="data-content" *ngIf="(isUnlimited && (!user.account.isSegmentFive && !user.account.isSegmentSix && !isCbmGemini))">
                    <xm-media-image class="logo" [imageOptions]="planLogoIcon" size="auto"></xm-media-image>
                    <div class="plan-title">{{ selectedPlanData.planName }}</div>
                </div>
                <div class="data-content" *ngIf="(isUnlimited && (user.account.isSegmentFive || user.account.isSegmentSix || isCbmGemini))">
                    <xm-media-image class="logo" [imageOptions]="planLogoIcon" size="auto"></xm-media-image>
                    <div *ngIf="(!isCbmUserSegmentFiveTabletUnlimited); else tabletUnlimitedSeg5" class="plan-title">{{ selectedPlanData.planName }}</div>
                    <ng-template #tabletUnlimitedSeg5>
                        <div class="plan-title-seg5-tabletunlimited">{{ selectedPlanData.planName }}</div>
                    </ng-template>
                </div>
                <div class="plan-inuse" *ngIf="isSuccess else dataRate">
                    <xm-media-image aria-hidden="true" size="auto" class="check-icon" [imageOptions]="checkIcon"></xm-media-image>
                    <span class="icon-subhead">{{ pageContent.inUse }}</span>
                </div>
                
                <ng-template #dataRate>
                    <div *ngIf="(!user.account.isSegmentFive && !user.account.isSegmentSix && !isCbmGemini)" class="data-rate">${{ selectedPlanData.pricePerUnit }}/{{ selectedPlanData.priceUnit }}</div>
                    <div *ngIf="(user.account.isSegmentFive || user.account.isSegmentSix || isCbmGemini)" class="data-rate">{{ selectedPlanData.pricePerUnit }}</div>
                    <cms-text class="disc-text" *ngIf="isDiscountPromotion && isCbmGemini" [originalText]="pageContent.cbmGeminiDiscountContent"></cms-text>
                </ng-template>
            </div>
        </div>
        <div class="logo-block" *ngIf="isFailure">
            <xm-media-image aria-hidden="true" size="auto" [imageOptions]="failureIcon"></xm-media-image>
        </div>
        <p class="description" *ngIf="subhead">{{ subhead }}</p>
    </div>
    <div class="actions">
        <div class="disclaimer" *ngIf="pageContent.disclaimer">
            <xm-media-image aria-hidden="true" class="email-icon" size="height" [imageOptions]="emailIcon"></xm-media-image>
            <cms-text class="disc-text" [originalText]="pageContent.disclaimer"></cms-text>
        </div>
        <xm-plan-switch-promotions
            *ngIf="(isDiscountPromotion && !isFailure && !isUnlimited && !isIcopPlanSwitch)"
            [promotionType]="promotionType"
            [promotionContent]="promoContent"
            [resultPage]="true">
        </xm-plan-switch-promotions>
        <div *ngIf="(isIcopPlanSwitch && !isUnlimited && !isFailure)">
            <div class="icop-promotion" *ngFor="let promotionContent of allPromoContent">
                <div
                    [ngClass]="promotionContent.type === 'notification' ? 'promo-content-notification' : 'promo-content-alert'">
                    <xm-media-image class="icon" [imageOptions]="getPromoIcon(promotionContent.icon)"></xm-media-image>
                    <p>{{ promotionContent.success }}</p>
                </div>
            </div>
        </div>
        <div class="buttons">
            <button *ngIf="isFailure" class="xm-btn-link-light cancel-btn" (click)="continue()">{{ pageContent.cancel }}</button>
            <button *ngIf="pageContent.cta" class="xm-btn-primary-dark action-btn" (click)="continue(isFailure)">{{ pageContent.cta }}</button>
        </div>
    </div>
</section>
